   import Home from "../pages/Home";
   import Courses from "../pages/Courses";
   import FullStack from "../pages/FullStack";
   import ReactNative from "../pages/ReactNative";
   import Python from "../pages/Python";
   import DataScience from "../pages/DataScience";
   import Django from "../pages/Django";
   import DevOps from "../pages/DevOps";
   import FlutterApp from "../pages/FlutterApp";
   import UIUX from "../pages/UIUX";
   import FrontEndWebDevelopment from "../pages/FrontEndWebDevelopment";
   import FullStackJava from "../pages/FullStackJava";
   import AI from "../pages/AI";
   import DigitalMarketing from "../pages/DigitalMarketing";
   import RHCSA from "../pages/RHCSA";
   import RHCE from "../pages/RHCE";
   import Oracle from "../pages/Oracle";
   import AIML from "../pages/AIML";
   import CCNA from "../pages/CCNA";
   import CCNP from "../pages/CCNP";
   import BootCamp from "../pages/BootCamp";
   import MyLearning from "../pages/MyLearning";
   import Login from "../pages/Login";
   import Signup from "../pages/Signup";
   import SendInquiry from "../pages/SendInquiry";
   import AboutUs from "../pages/AboutUs";
   import Career from "../pages/Career";
   import Blogs from "../pages/Blogs";
   import BlogDetail from "../pages/BlogDetail"; // Add this
   import PrivacyPolicy from "../pages/PrivacyPolicy";
   import RefundPolicy from "../pages/RefundPolicy";
   import Term from "../pages/Term";
   import FonePay from "../pages/FonePay";
   import Inquiry from "../pages/Inquiry";
   import JoinClass from "../pages/JoinClass";
   import Reports from "../pages/Reports";
   import PrivateRoute from "../components/PrivateRoute";
   import Edit from "../pages/Edit.jsx";

   const routes = [
     {
       path: "/",
       element: <Home />,
     },
     {
       path: "/courses",
       element: <Courses />,
     },
     {
       path: "/courses/full-stack-mern",
       element: <FullStack />,
     },
     {
       path: "/courses/react-native",
       element: <ReactNative />,
     },
     {
       path: "/courses/python",
       element: <Python />,
     },
     {
       path: "/courses/data-science",
       element: <DataScience />,
     },
     {
       path: "/courses/django",
       element: <Django />,
     },
     {
       path: "/courses/devops",
       element: <DevOps />,
     },
     {
       path: "/courses/flutter-app-development",
       element: <FlutterApp />,
     },
     {
       path: "/courses/uiux-design",
       element: <UIUX />,
     },
     {
       path: "/courses/frontend-web-development",
       element: <FrontEndWebDevelopment />,
     },
     {
       path: "/courses/full-stack-java",
       element: <FullStackJava />,
     },
     {
       path: "/courses/digital-marketing",
       element: <DigitalMarketing />,
     },
     {
       path: "/courses/ai",
       element: <AI />,
     },
     {
       path: "/courses/rhcsa",
       element: <RHCSA />,
     },
     {
       path: "/courses/rhce",
       element: <RHCE />,
     },
     {
       path: "/courses/oracle",
       element: <Oracle />,
     },
     {
       path: "/courses/aiml",
       element: <AIML />,
     },
     {
       path: "/courses/ccna",
       element: <CCNA />,
     },
     {
       path: "/courses/ccnp",
       element: <CCNP />,
     },
     {
       path: "/login",
       element: <Login />,
     },
     {
       path: "/my-learning",
       element: <MyLearning />,
     },
     {
       path: "/bootcamp",
       element: <BootCamp />,
     },
     {
       path: "/create-account",
       element: <Signup />,
     },
     {
       path: "/send-inquiry",
       element: <SendInquiry />,
     },
     {
       path: "/about",
       element: <AboutUs />,
     },
     {
       path: "/career",
       element: <Career />,
     },
     {
       path: "/blogs",
       element: <Blogs />,
     },
     {
       path: "/blogs/:id",
       element: <BlogDetail />, // Add this
     },
     {
       path: "/privacy-policy",
       element: <PrivacyPolicy />,
     },
     {
       path: "/refund-policy",
       element: <RefundPolicy />,
     },
     {
       path: "/terms-conditions",
       element: <Term />,
     },
     {
       path: "/fonepay",
       element: <FonePay />,
     },
     {
       path: "/inquiry",
       element: <Inquiry />,
       protected: true,
     },
     {
       path: "/join-class",
       element: <JoinClass />,
     },
     {
       path: "/reports",
       element: <Reports />,
       protected: true,
     },
     {
       path: "/edit",
       element: <Edit />,
       protected: true,
     },
   ];

   export default routes;
   
